import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const UpcomingBookings = ({ 
  bookings, 
  onCancel,
  onViewDetails 
}) => {
  if (bookings?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg shadow-md p-6 md:p-8 lg:p-10">
        <div className="flex flex-col items-center justify-center text-center py-8">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-muted rounded-full flex items-center justify-center mb-4">
            <Icon name="Calendar" size={32} color="var(--color-muted-foreground)" />
          </div>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2">
            No Upcoming Classes
          </h3>
          <p className="text-sm md:text-base text-muted-foreground max-w-sm">
            You haven't booked any classes yet. Browse the schedule to find classes that match your fitness goals.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg shadow-md p-4 md:p-5 lg:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h2 className="text-lg md:text-xl lg:text-2xl font-heading font-semibold text-foreground">
          Your Bookings
        </h2>
        <span className="px-3 py-1 bg-accent/10 text-accent rounded-full text-sm font-medium caption">
          {bookings?.length} {bookings?.length === 1 ? 'class' : 'classes'}
        </span>
      </div>
      <div className="space-y-3 md:space-y-4">
        {bookings?.map((booking) => (
          <div 
            key={booking?.id}
            className="bg-muted/50 border border-border rounded-lg p-4 transition-smooth hover:shadow-md"
          >
            <div className="flex flex-col md:flex-row md:items-center gap-4">
              <div className="flex items-start gap-3 flex-1 min-w-0">
                <div className="relative w-12 h-12 md:w-14 md:h-14 flex-shrink-0">
                  <Image
                    src={booking?.instructorImage}
                    alt={booking?.instructorImageAlt}
                    className="w-full h-full rounded-lg object-cover"
                  />
                </div>
                
                <div className="flex-1 min-w-0">
                  <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-1 line-clamp-1">
                    {booking?.name}
                  </h3>
                  <p className="text-sm text-muted-foreground mb-2 line-clamp-1">
                    with {booking?.instructor}
                  </p>
                  <div className="flex flex-wrap items-center gap-3 text-xs md:text-sm text-muted-foreground">
                    <div className="flex items-center gap-1">
                      <Icon name="Calendar" size={14} />
                      <span className="whitespace-nowrap">{booking?.date}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="Clock" size={14} />
                      <span className="whitespace-nowrap">{booking?.time}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="MapPin" size={14} />
                      <span className="whitespace-nowrap">{booking?.location}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex gap-2 md:flex-col md:w-auto">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onViewDetails(booking?.id)}
                  iconName="Info"
                  iconSize={16}
                  className="flex-1 md:flex-none md:w-full"
                >
                  Details
                </Button>
                <Button
                  variant="destructive"
                  size="sm"
                  onClick={() => onCancel(booking?.id)}
                  iconName="X"
                  iconSize={16}
                  className="flex-1 md:flex-none md:w-full"
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpcomingBookings;